import { type ColumnOption } from "interfaces/columnOptions";
import { type CampaignOverview } from "../types/state";
import { Title } from "../../../../../components/listViewTemplates";
import { Tooltip } from "components/common/tooltip";
import { TextTruncate } from "components";
import { PublishStatus } from "components/common/PublishStatus";
import { PublishedStatusTypes } from "enums";
import dateTimeUtils from "utils/dateTimeUtils";
import { CampaignItemMenu } from "./CampaignItemMenu";

export enum Columns {
  Name = "Name",
  Type = "Type",
  Publisher = "Publisher",
  Status = "Status",
  Added = "Added",
  Modified = "Modified",
}

export const ColumnToParamMap: {
  [P in Lowercase<Columns>]: string;
} = {
  name: "name",
  type: "type",
  publisher: "publisher",
  status: "isDraft",
  added: "dateCreated",
  modified: "dateModified",
};

interface GetColumnOptionsParams {
  readonly?: boolean;
  onEditClick: (id: number, isDraft: boolean) => void;
  onDuplicate: (id: number) => void;
  onSendTestClick: (id: number) => void;
  isMobo: boolean;
  onDelete: (id: number) => void;
}

export const getColumnOptions = (params: GetColumnOptionsParams): ColumnOption<CampaignOverview>[] => {
  return [
    {
      name: Columns.Name,
      width: 3,
      isSortable: true,
      render: (item) => <Title url={item.id.toString()} title={item.title} clamp={2} className="normal-color" />,
    },
    {
      name: Columns.Type,
      width: 2,
      isSortable: false,
      render: (item: CampaignOverview) => item.type,
    },
    {
      name: Columns.Publisher,
      width: 2,
      isSortable: false,
      render: (item: CampaignOverview) => (
        <Tooltip target={<TextTruncate>{item.publisher}</TextTruncate>} content={item.publisher} />
      ),
    },
    {
      name: Columns.Status,
      width: 3,
      isSortable: false,
      render: (item: CampaignOverview) => (
        <PublishStatus
          publishedStatus={PublishedStatusTypes.ConvertToPublishedStatusType(!item.isDraft, item.hasBeenPublished)}
        />
      ),
    },
    {
      name: Columns.Added,
      width: 2,
      isSortable: true,
      render: (item: CampaignOverview) => dateTimeUtils.formatDate(item.dateCreated),
    },
    {
      name: Columns.Modified,
      width: 2,
      isSortable: true,
      render: (item: CampaignOverview) => dateTimeUtils.formatDate(item.dateModified),
    },
    {
      name: "",
      width: 1,
      className: "align-right",
      isSortable: false,
      render: (item: CampaignOverview, isChecked?: boolean) => {
        return (
          <CampaignItemMenu
            circle
            outlinedEllipsis
            item={item}
            isChecked={isChecked}
            readonly={params.readonly}
            hasPermission={!params.readonly}
            onEditClick={params.onEditClick}
            onDuplicate={params.onDuplicate}
            onSendTestClick={params.onSendTestClick}
            isMobo={params.isMobo}
            onDelete={params.onDelete}
          />
        );
      },
    },
  ];
};
